import { PayloadAction } from '@reduxjs/toolkit';

import { IUser } from '../../auth/interfaces/IUser';
import { UserTypes } from '../../auth/enums/UserTypes';
import { UserLoginDestinationType } from '../../auth/enums/UserLoginDestinationType';

export const UserReducer = {
	setDocument: (state: IUser, action: PayloadAction<any>) => {
		state.document_type = action.payload;
	},

	setUserType: (state: IUser, action: PayloadAction<UserTypes>) => {
		state.user_type = action.payload;
	},

	setToken: (state: IUser, action: PayloadAction<string>) => {
		state.token = action.payload;
	},

	setUser: (state: IUser, action: PayloadAction<IUser>) => {
		state.email = action.payload.email;
		state.id = action.payload.id;
		state.logged_type = action.payload.logged_type;
		state.user_hash = action.payload.user_hash;
		state.user_type = action.payload.user_type;
		state.username = action.payload.username;
		state.cognito_id = action.payload.cognito_id;
		state.destination = action.payload.destination;
		state.first_name = action.payload.first_name;
		state.last_name = action.payload.last_name;
		state.token = action.payload.token;
		state.role = action.payload.role;
		state.first_ipaf = action.payload.first_ipaf;
	},

	setUserDestination: (
		state: IUser,
		action: PayloadAction<UserLoginDestinationType>
	) => {
		state.destination = action.payload;
	},

	setPendingIpaf: (state: IUser, action: PayloadAction<number>) => {
		state.pending_ipaf_review = action.payload;
	},

	setInProgressIpaf: (state: IUser, action: PayloadAction<number>) => {
		state.in_progress_ipaf = action.payload;
	},

	setIsRenewingUser: (state: IUser, action: PayloadAction<any>) => {
		state.is_renewing_user = action.payload.is_renewing_user;
		state.renewal_products = action.payload.products;
	},

	setUserFormId: (state: IUser, action: PayloadAction<any>) => {
		state.user_form_id = action.payload;
	},

	toggleIsFirstIpaf: (state: IUser, action: PayloadAction<any>) => {
		state.first_ipaf = action.payload;
	},

	setHasCyber: (state: IUser, action: PayloadAction<boolean>) => {
		state.has_cyber_insurance = action.payload;
	},
	setUploadInProcess: (state: IUser, action: PayloadAction<boolean>) => {
		state.upload_in_process = action.payload;
	},
	setLastIpafTag: (state: IUser, action: PayloadAction<string>) => {
		state.last_ipaf = action.payload
	}
};
